module.exports = __webpack_public_path__ + "assets/img/modal-avatar-48b4e54e.png";